<main [ngClass]="{'main-promotion' : isPromotion || notificationEnabled}" id="sms-seo">
  <div id="home-slider" class="carousel slide" data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <div class="w-100 d-block d-sm-none ">
          <picture class="w-100">
            <source
              srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-360x640.webp 360w, https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-450x800-59.webp 450w, https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-945x1680.webp 945w"
              type="image/webp">
            <source
              srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-360x640.png 360w, https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-450x800-59.png 450w, https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-945x1680.png 945w"
              type="image/png">
            <img class="w-100" src="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-360x640.png"
              alt="SMS a Cuba - Cubatel">
          </picture>
        </div>
        <div class=" w-100 d-none d-sm-block d-md-none ">
          <picture class="w-100">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-800x600-60.webp"
              type="image/webp">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-800x600-60.png" type="image/png">
            <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-800x600-60.png"
              alt="SMS a Cuba - Cubatel">
          </picture>
        </div>
        <div class=" w-100 d-none d-md-block d-xl-none ">
          <picture class="w-100">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-1024x768-58.webp"
              type="image/webp">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-1024x768-58.png" type="image/png">
            <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-1024x768-58.png"
              alt="SMS a Cuba - Cubatel">
          </picture>
        </div>
        <div class=" w-100 d-none d-xl-block d-xxl-none ">
          <picture class="w-100">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-1366x760-57.webp"
              type="image/webp">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-1366x760-57.png" type="image/png">
            <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-1366x760-57.png"
              alt="SMS a Cuba - Cubatel">
          </picture>
        </div>
        <div class=" w-100 d-none d-xxl-block ">
          <picture class="w-100">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-2560x1086-56.png"
              type="image/webp">
            <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-2560x1086-56.png"
              type="image/png">
            <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/sms/mensajes_image-01-2560x1086-56.png"
              alt="SMS a Cuba - Cubatel">
          </picture>
        </div>
        <div [ngClass]="{'promotion': isPromotion || notificationEnabled}"
          class="banner-container col-12 col-md-6 col-lg-6 col-sm-7 col-xxl-5 col-xs-12">
          <h1 class="text-center banner-title first">ENVÍA SMS A CUBA</h1>
          <h2 class="text-center banner-title second primary-color font-italic bold"><span class="bold">DESDE </span>
            <span class="price bold">0.04
            </span><span class="bold">USD</span></h2>
          <h3 class="banner-sub-title px-4">
            La mejor tarifa en el mercado
          </h3>
          <a class="btn btn-primary banner-button" routerLink="/sms" routerLinkActive="active">ENVIAR SMS <i
              class="stu stu-icon-sms white ml-2"></i></a>
        </div>

      </div>
    </div>
  </div>
  <section class="services col-lg-12 col-12 d-inline-flex flex-wrap">
    <article class="col-lg-2 col-md-6 col-sm-3 col-6 pr-2 mt-2">
      <a class="llamadas" routerLink="/llamadas-a-cuba">
        <div>
          <i class="stu stu-icon-calls white"></i>
          <p>llamadas</p>
        </div>
      </a>
    </article>
    <article class="col-lg-2 col-md-6 col-sm-3 col-6 pr-2 mt-2">
      <a class="recargas" *ngIf="routerLinkRecarga == '/'" [routerLink]="[routerLinkRecarga]">
        <div>
          <i class="stu stu-icon-recharche white"></i>
          <p>recargas</p>
        </div>
      </a><a class="recargas" *ngIf="routerLinkRecarga != '/'" [routerLink]="[routerLinkRecarga]">
        <div>
          <i class="stu stu-icon-recharche white"></i>
          <p>recargas</p>
        </div>
      </a>
    </article>
    <article class="col-lg-2 col-md-6 col-sm-3 col-6 pr-2 mt-2">
      <a class="nauta" [routerLink]="routerLinkNauta">
        <div>
          <i class="stu stu-icon-nauta white"></i>
          <p>nauta</p>
        </div>
      </a>
    </article>
    <article class="col-lg-2 col-md-6 col-sm-3 col-6 pr-2 mt-2">
      <a class="active mensajes" [routerLink]="routerLinkSms">
        <div>
          <i class="stu stu-icon-sms white"></i>
          <p>mensajes</p>
        </div>
      </a>
    </article>
  </section>
  <section class="porque how-to-faq col-xxl-12 col-12 d-md-inline-flex flex-wrap pb-4">
    <div class="w-100 col-12 col-md-12 d-inline-flex justify-content-center flex-row flex-wrap info">
      <p class="text-left col-12 col-sm-6 pb-5 pb-sm-0">Envía mensajes a Cuba por <span class="bold">solo 0.04
          centavos</span>. <br>¡Imposible que lo encuentres
        más barato!
      </p>
      <p class="text-left col-12 col-sm-6">Puedes enviar tus mensajes desde este sitio web o desde la
        aplicación de
        Cubatel, disponible para <a class="normal" target="_blank"
          href="https://itunes.apple.com/us/app/cubatel/id1300396049" rel="noreferrer"
          routerLinkActive="active">iPhone</a> y <a class="normal" target="_blank" rel="noreferrer"
          href="https://play.google.com/store/apps/details?id=com.cubatel.android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
          routerLinkActive="active">Android</a>. Es sencillo:<br>1- Regístrate en Cubatel<br>2- Compra un paquete de
        SMS<br>3- ¡Comienza a enviar tus mensajes!
      </p>
    </div>
    <div class="show-to col-md-6">
      <div class="col-12 col-md-12 mt-4 mb-4">
        <h2 class="text-center bold fontweight800">¿Cómo hago para…?</h2>
      </div>
      <div class="accordion w-100" id="how-to">
        <div class="card">
          <div class="card-header" id="howToHeadingOne" data-toggle="collapse" data-target="#howToCollapseOne">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link  text-left nowrap" type="button" data-toggle="collapse"
                data-target="#howToCollapseOne" aria-expanded="false" aria-controls="howToCollapseOne">
                ¿Cómo compro paquetes de SMS desde el sitio web de Cubatel?
              </button>
            </h3>
          </div>
          <div id="howToCollapseOne" class="collapse" aria-labelledby="howToHeadingOne" data-parent="#how-to">
            <div class="card-body">
              <p class=" w-100 text-justify ">- Regístrese en el sitio de Cubatel o inicie sesión en su cuenta
              </p>
              <p class=" w-100 text-justify ">- Haga <span class="bold">click</span> en la opción Mensajes del Menú
                principal
              </p>
              <p class=" w-100 text-justify ">- Haga <span class="bold">click</span> en el botón "+ Comprar SMS"</p>
              <p class=" w-100 text-justify ">- Seleccione el paquete que prefiera
              </p>
              <p class=" w-100 text-justify ">- Proceda a completar los datos del pago</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="howToHeadingFive" data-toggle="collapse" data-target="#howToCollapseFive">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link  text-left nowrap" type="button" data-toggle="collapse"
                data-target="#howToCollapseFive" aria-expanded="false" aria-controls="howToCollapseFive">
                ¿Cómo compro paquetes de SMS desde la aplicación de Cubatel?
              </button>
            </h3>
          </div>
          <div id="howToCollapseFive" class="collapse" aria-labelledby="howToHeadingFive" data-parent="#how-to">
            <div class="card-body">
              <p class=" w-100 text-justify ">- Descargue gratis la aplicaciónde Cubatel en <a class="normal"
                  href="https://play.google.com/store/apps/details?id=com.cubatel.android&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  target="_blank" rel="noreferrer">Google Play</a> y <a class="normal"
                  href="https://itunes.apple.com/us/app/cubatel/id1300396049" target="_blank" rel="noreferrer">App
                  Store</a>. Regístrese e inicie sesión
              </p>
              <p class=" w-100 text-justify ">- Si ya tiene la aplicación, ábrala en su celular</p>
              <p class=" w-100 text-justify ">- Vaya al icono Mensajes en la parte inferior de la app.
              </p>
              <p class=" w-100 text-justify ">- Pulse el número de SMS disponibles que se muestra en la parte superior
                izquierda de la pantalla. Elija el paquete que desee y proceda con el pago.
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="howToHeadingTwo" data-toggle="collapse" data-target="#howToCollapseTwo">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                data-target="#howToCollapseTwo" aria-expanded="false" aria-controls="howToCollapseTwo">
                ¿Cómo puedo enviar SMS a Cuba desde el sitio web de Cubatel?
              </button>
            </h3>
          </div>
          <div id="howToCollapseTwo" class="collapse" aria-labelledby="howToHeadingTwo" data-parent="#how-to">
            <div class="card-body">
              <p class=" w-100 text-justify ">- Regístrese en el sitio de Cubatel o inicie sesión en su cuenta
              </p>
              <p class=" w-100 text-justify ">- Haga <span class="bold">click</span> en la opción Mensajes del Menú
                principal
              </p>
              <p class=" w-100 text-justify ">- Introduzca el nombre del contacto. Si ya ha enviado SMS a ese
                contacto, el sistema le permitirá seleccionar y autocompletar la información necesaria. De lo contrario,
                complete los campos requeridos de nombre y número de teléfono.
              </p>
              <p class=" w-100 text-justify ">- Escriba el cuerpo del SMS
              </p>
              <p class=" w-100 text-justify ">- Haga <span class="bold">click</span> en la
                función 'No soy un robot' para validar que no
                es un usuario malintencionado atacando el sistema
              </p>
              <p class=" w-100 text-justify ">- Seleccione ENVIAR SMS
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="howToHeadingSix" data-toggle="collapse" data-target="#howToCollapseSix">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                data-target="#howToCollapseSix" aria-expanded="false" aria-controls="howToCollapseSix">
                ¿Cómo puedo enviar SMS a Cuba desde la aplicación de Cubatel?
              </button>
            </h3>
          </div>
          <div id="howToCollapseSix" class="collapse" aria-labelledby="howToHeadingSix" data-parent="#how-to">
            <div class="card-body">
              <p class=" w-100 text-justify ">- Descargue gratis la aplicaciónde Cubatel en <a class="normal"
                  href="https://play.google.com/store/apps/details?id=com.cubatel.android&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  target="_blank" rel="noreferrer">Google Play</a> y <a class="normal"
                  href="https://itunes.apple.com/us/app/cubatel/id1300396049" target="_blank" rel="noreferrer">App
                  Store</a>. Regístrese
                e inicie sesión
              </p>
              <p class=" w-100 text-justify ">- Si ya tiene la aplicación, ábrala en su celular</p>
              <p class=" w-100 text-justify ">- Vaya al icono Mensajes, en la parte inferior de la app.
              </p>
              <p class=" w-100 text-justify ">- Pulse el botón de componer, en la parte superior derecha. Introduzca el
                nombre del contacto. Nuestro sistema guarda automáticamente sus contactos y a la hora de escribir un
                mensaje solo tiene que comenzar a teclear su nombre y el sistema le permitirá seleccionar y
                autocompletar la información necesaria. En caso de no tener contactos guardados, introduzca su
                información. Esta será salvada automáticamente
              </p>
              <p class=" w-100 text-justify ">- Envíe su mensaje.
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="howToHeadingThree" data-toggle="collapse" data-target="#howToCollapseThree">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link  text-left nowrap" type="button" data-toggle="collapse"
                data-target="#howToCollapseThree" aria-expanded="false" aria-controls="howToCollapseThree">
                ¿Cómo puedo ver el historial de SMS enviados desde el sitio web de Cubatel?
              </button>
            </h3>
          </div>
          <div id="howToCollapseThree" class="collapse" aria-labelledby="howToHeadingThree" data-parent="#how-to">
            <div class="card-body">
              <p class=" w-100 text-justify ">- Haga <span class="bold">click</span> en la opción Mi perfil del Menú
                principal. Luego seleccione la opción Mensajes.
              </p>
            </div>
          </div>
          <div class="card">
            <div class="card-header" id="howToHeadingFour" data-toggle="collapse" data-target="#howToCollapseFour">
              <h3 class="mb-0 text-left">
                <button class="btn btn-link  text-left nowrap" type="button" data-toggle="collapse"
                  data-target="#howToCollapseFour" aria-expanded="false" aria-controls="howToCollapseFour">
                  ¿Cómo puedo borrar un SMS de mi historial?
                </button>
              </h3>
            </div>
            <div id="howToCollapseFour" class="collapse" aria-labelledby="howToHeadingFour" data-parent="#how-to">
              <div class="card-body">
                <p class=" w-100 text-justify ">
                  - Para acceder a su historial de SMS en el sitio web de Cubatel, haga click en la opción Mi perfil del
                  Menú principal.</p>

                <p class=" w-100 text-justify ">
                  - Vaya a Mensajes</p>
                <p class=" w-100 text-justify ">
                  - Elija el SMS que desea eliminar y presione la cesta de basura roja, situada a la derecha del SMS.
                </p>
                <p class=" w-100 text-justify ">
                  - Confirme la acción haciendo click en Eliminar</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sfaq col-md-6">
      <div class="col-12 col-md-12 mt-4 mb-4">
        <h2 class="text-center bold fontweight800">Preguntas Frecuentes</h2>
      </div>
      <div class="accordion w-100" id="faq">
        <div class="card">
          <div class="card-header" id="faqHeadingOne" data-toggle="collapse" data-target="#faqCollapseOne">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link  text-left nowrap" type="button" data-toggle="collapse"
                data-target="#faqCollapseOne" aria-expanded="false" aria-controls="faqCollapseOne">
                ¿Cuánto cuestan los SMS a Cuba?
              </button>
            </h3>
          </div>
          <div id="faqCollapseOne" class="collapse" aria-labelledby="faqHeadingOne" data-parent="#faq">
            <div class="card-body">
              <p class=" w-100 text-justify ">
                El servicio de SMS se ofrece por paquetes. Estos son: 120 mensajes por 5.00 USD y 250 mensajes por
                10.00
                USD.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="faqHeadingTwo" data-target="#faqCollapseTwo" data-toggle="collapse">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                data-target="#faqCollapseTwo" aria-expanded="false" aria-controls="faqCollapseTwo">
                ¿Qué vigencia tienen los paquetes de SMS de Cubatel?
              </button>
            </h3>
          </div>
          <div id="faqCollapseTwo" class="collapse" aria-labelledby="faqHeadingTwo" data-parent="#faq">
            <div class="card-body">
              <p class=" w-100 text-justify ">
                Los paquetes de Mensajes a Cuba son de vigencia ilimitada, además de que a medida que usted haga
                recargas Cubacel o Nauta se le suman 3 mensajes gratis.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="faqHeadingThree" data-target="#faqCollapseThree" data-toggle="collapse">
            <h3 class="mb-0 text-left">
              <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                data-target="#faqCollapseThree" aria-expanded="false" aria-controls="faqCollapseThree">
                ¿Cuántos caracteres deben tener mis SMS a Cuba?
              </button>
            </h3>
          </div>
          <div id="faqCollapseThree" class="collapse" aria-labelledby="faqHeadingThree" data-parent="#faq">
            <div class="card-body">
              <p class=" w-100 text-justify ">
                Puede enviar mensajes de hasta 160 caracteres.</p>
            </div>
          </div>
        </div>
      </div>
    </div>


  </section>
  <section class="porque apps col-xxl-12 col-12 d-md-inline-flex text-center">
    <picture class="w-100 d-block d-sm-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-450x450.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-450x450.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-450x450.png"
        alt="Aplicación para llamar y enviar SMS y recargas a Cuba">
    </picture>
    <picture class="w-100 d-none d-sm-block d-md-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-800x230-14.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-800x230-14.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-800x230-14.png"
        alt="Aplicación para llamar y enviar SMS y recargas a Cuba">
    </picture>
    <picture class="w-100 d-none d-md-block d-xl-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-1024x295-13.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-1024x295-13.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-1024x295-13.png"
        alt="Aplicación para llamar y enviar SMS y recargas a Cuba">
    </picture>
    <picture class="w-100 d-none d-xl-block d-xxl-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-1366x340-12.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-1366x340-12.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-1366x340-12.png"
        alt="Aplicación para llamar y enviar SMS y recargas a Cuba">
    </picture>
    <picture class="w-100 d-none d-xxl-block">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-2560x1086.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-2560x1086.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/cta-apps/recarga_image-02-2560x1086.png"
        alt="Aplicación para llamar y enviar SMS y recargas a Cuba">
    </picture>
    <div class="cta text-center w-100 text-white">
      <div class="apps-space d-none d-lg-block"></div>
      <h3 class="apps-title p-3 text-center d-block d-sm-none d-md-block">¡Con la aplicación de Cubatel es más fácil<br>
        hacer recargas, llamar y enviar
        mensajes!</h3>
      <h3 class="apps-title p-3 text-center d-none d-sm-block d-md-none">¡Con la aplicación de Cubatel<br> es más fácil
        hacer recargas,<br> llamar y enviar
        mensajes!</h3>

      <div class="apps-links p-3 pl-sm-0 pl-lg-3 pr-lg-0">
        <h2 class="bold fontweight800">¡DESCÁRGALA AQUÍ!</h2>
        <div><a class="mr-4 google-play" target="_blank" rel="noreferrer"
            href="https://play.google.com/store/apps/details?id=com.cubatel.android&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
            <picture>
              <source data-srcset="assets/apps/app-google-play.webp" type="image/webp">
              <source data-srcset="assets/apps/app-google-play.png" type="image/png">
              <img class="lazyload" width="138" alt="Google Play" data-src="assets/apps/app-google-play.png">
            </picture>

          </a>
          <a class="app-store" target="_blank" href="https://itunes.apple.com/us/app/cubatel/id1300396049"
            rel="noreferrer">
            <picture>
              <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/apps/app-store.webp" type="image/webp">
              <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/apps/app-store.png" type="image/png">
              <img class="lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/apps/app-store.png" alt="App Store">
            </picture>

          </a></div>
      </div>
      <div class="apps-space d-none d-lg-block"></div>
    </div>
  </section>

  <section class="secondary-banner col-lg-12 col-12 d-sm-inline-flex p-0 hola">
    <picture class="w-100 d-block d-sm-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-450x800.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-450x800.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-450x800.png"
        alt="Recarga celular Cuba">
    </picture>
    <picture class="w-100 d-none d-sm-block d-md-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-800x600.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-800x600.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-800x600.png"
        alt="Recarga celular Cuba">
    </picture>
    <picture class="w-100 d-none d-md-block d-xl-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-1024x768.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-1024x768.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-1024x768.png"
        alt="Recarga celular Cuba">
    </picture>
    <picture class="w-100 d-none d-xl-block d-xxl-none">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-1366x760.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-1366x760.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-1366x760.png"
        alt="Recarga celular Cuba">
    </picture>
    <picture class="w-100 d-none d-xxl-block">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-2560x1086.webp" type="image/webp">
      <source data-srcset="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-2560x1086.png" type="image/png">
      <img class="w-100 lazyload" data-src="https://www.cubatel.com/images-ads/cdn/assets/recharge/recarga_image-03-2560x1086.png"
        alt="Recarga celular Cuba">
    </picture>
    <div class="secondary-banner-container col-12 col-md-8 col-sm-7 col-lg-7 col-xl-6 col-xxl-5">
      <h2 class="text-center secondary-banner-title primary-color bold fontweight800">¡PROMOCIÓN DE BIENVENIDA!
      </h2>
      <h3 class="sub-title">Regístrate ahora y obtén un descuento</h3>
      <ul class="pl-0">
        <li class="text-center h5">
          Crea una cuenta de usuario en Cubatel
        </li>
        <li class="text-center h5">
          y elige una de las tres promociones
        </li>
        <li class="text-center h5">
          que preparamos para recibirte
        </li>
      </ul>
      <button class="btn btn-primary banner-button" (click)="signUp()">¡QUIERO REGISTRARME!</button>
    </div>
  </section>
  <ng-container #recharge_steps_section></ng-container>

</main>
